import { useSetAtom } from 'jotai';
import pdpIsEditOrderSuccessAtom from './pdpIsEditOrderSuccessAtom';
const useSetPdpIsEditOrderSuccess = () => {
  const setPdpIsEditOrderSuccess = useSetAtom(pdpIsEditOrderSuccessAtom);
  return setPdpIsEditOrderSuccess;
};
export default useSetPdpIsEditOrderSuccess;